import { Navigate, useLocation, useParams } from 'react-router-dom';
import SeoLandingPage from '../components/SeoLandingPage';
import { seoLandingPages } from '../content/seoLandingPages';

const SeoLandingPageRoute = () => {
  const location = useLocation();
  const { seoSlug } = useParams<{ seoSlug: string }>();
  const lookupPath = seoSlug ? `/${seoSlug}` : location.pathname;
  const pageContent = seoLandingPages[lookupPath];

  if (!pageContent) {
    return <Navigate to="/" replace />;
  }

  const canonicalPath = `/seo${pageContent.slug}`;

  return (
    <SeoLandingPage
      title={pageContent.title}
      description={pageContent.description}
      canonicalUrl={`https://workflow.estate${canonicalPath}`}
      pagePath={canonicalPath}
      h1={pageContent.h1}
      heroSubtitle={pageContent.heroSubtitle}
      intro={pageContent.intro}
      keyBenefits={pageContent.keyBenefits}
      problemSolution={pageContent.problemSolution}
      featureHighlights={pageContent.featureHighlights}
      whyWorkflowEstate={pageContent.whyWorkflowEstate}
      deepDive={pageContent.deepDive}
      audienceFit={pageContent.audienceFit}
      faqItems={pageContent.faqItems}
      ctaHeading={pageContent.ctaHeading}
      ctaBody={pageContent.ctaBody}
      ctaPrimaryText={pageContent.ctaPrimaryText}
      ctaPrimaryTo={pageContent.ctaPrimaryTo}
      ctaSecondaryText={pageContent.ctaSecondaryText}
      ctaSecondaryTo={pageContent.ctaSecondaryTo}
      internalLinks={pageContent.internalLinks}
    />
  );
};

export default SeoLandingPageRoute;
